import { Routes, Route } from 'react-router-dom';
import ChangePassword from '../components/ChangePassword';
import ProfileUpdate from '../components/ProfileUpdate';
import AdminReports from '../../../Screens/Reports/AdminReports';
import ServiceForms from '../../../Screens/Booking/ServiceForm';
import BookingSummary from '../../../Screens/Booking/BookingSummary';
import PassengerDetails from '../../../Screens/Booking/PassengerDetails';
import BookingList from '../../../Screens/Booking/BookingsList';
import ViewBooking from '../../../Screens/Booking/ViewBooking';
import EditBooking from '../../../Screens/Booking/EditBooking';
import Payments from '../../../Screens/Payment/ViewPaymentList';
import ViewPayment from '../../../Screens/Payment/ViewPayment';
import AddressForm from '../../../Screens/Address/BillingAddress';
import AddAddressForm from '../../../Screens/Address/AddAddress';
import EditBillingAddressForm from '../../../Screens/Address/EditBillingAddressForm';
import CustomerDashBoard from '../components/CustomerDashBoard';
import SuccessPage from '../../../Screens/Booking/SuccessPage';
import AddFamilyMember from '../../../Screens/FamilyMembers/AddFamilyMember';
import {
  CUSTOMER_BOOKING_PASSENGER_DETAILS,
  CUSTOMER_DASHBOARD,
  CUSTOMER_VIEW_BOOKINGS,
  CUSTOMER_SUCCESS_PAGE,
  CUSTOMER_ADD_FAMILY_MEMBER,
  CUSTOMER_FAMILY_MEMBERS,
  CUSTOMER_EDIT_FAMILY_MEMBER,
  CUSTOMER_REFERRALS,
} from './CustomerRoutes';
import FamilyMembers from '../../../Screens/FamilyMembers/FamilyMembers';
import EditFamilyMember from '../../../Screens/FamilyMembers/EditFamilyMember';
import {
  PAYMENT_CANCLED,
  PAYMENT_FAILURE,
  PAYMENT_PROCESSING,
  PAYMENT_SUCCESS,
} from './AppRoutes';
import PaymentSuccess from '../../../Screens/Payment/PaymentSuccess';
import PaymentFailure from '../../../Screens/Payment/PaymentFailure';
import PaymentProcessingPage from '../../../Screens/Payment/PaymentProcessingPage';
import PaymentCancellation from '../../../Screens/Payment/PaymentCancle';
import { CustomerReferralPage } from '../../../Screens/Customer/CustomerReferralPage';

const CustomerAuthenticatedRoutes = () => (
  <Routes>
    <Route path={CUSTOMER_DASHBOARD} element={<CustomerDashBoard />} />
    <Route path='/customer/change-password' element={<ChangePassword />} />
    <Route path='/customer/profile' element={<ProfileUpdate />} />
    <Route path='/customer/reports' element={<AdminReports />} />
    <Route path='/customer/bookings/airport-data' element={<ServiceForms />} />
    <Route path='/customer/bookings/summary' element={<BookingSummary />} />
    <Route
      path={CUSTOMER_BOOKING_PASSENGER_DETAILS}
      element={<PassengerDetails />}
    />
    <Route path='/customer/bookings' element={<BookingList />} />
    <Route path={CUSTOMER_VIEW_BOOKINGS} element={<ViewBooking />} />
    <Route path='/customer/bookings/edit' element={<EditBooking />} />
    <Route path='/customer/invoices' element={<Payments />} />
    <Route path='/customer/invoices/view' element={<ViewPayment />} />
    <Route path='/customer/address' element={<AddressForm />} />
    <Route path='/customer/address/add' element={<AddAddressForm />} />
    <Route
      path='/customer/address/edit/:id'
      element={<EditBillingAddressForm />}
    />
    <Route path={CUSTOMER_SUCCESS_PAGE} element={<SuccessPage />} />
    <Route path={CUSTOMER_ADD_FAMILY_MEMBER} element={<AddFamilyMember />} />
    <Route path={CUSTOMER_FAMILY_MEMBERS} element={<FamilyMembers />} />
    <Route path={CUSTOMER_EDIT_FAMILY_MEMBER} element={<EditFamilyMember />} />
    <Route path={PAYMENT_SUCCESS} element={<PaymentSuccess />} />
    <Route path={PAYMENT_FAILURE} element={<PaymentFailure />} />
    <Route path={PAYMENT_CANCLED} element={<PaymentCancellation />} />
    <Route path={PAYMENT_PROCESSING} element={<PaymentProcessingPage />} />
    <Route path={CUSTOMER_REFERRALS} element={<CustomerReferralPage />} />
  </Routes>
);

export default CustomerAuthenticatedRoutes;
